angular.module('languages')

.directive('ngTranslateLanguageSelect', function () { 

	'use strict';

	return {
		restrict: 'A',
		replace: true,
		template: ''+
		'<div class="btn-group dropup" uib-dropdown>'+
		'	<div uib-dropdown-toggle>'+
		'		{{langCtrl.currentLocaleDisplayName}} <span class="caret"></span>'+
		'	</div>'+
		'	<ul class="dropdown-menu" role="menu" uib-dropdown-menu>'+
		'		<li><a href="#" ng-repeat="localesDisplayName in langCtrl.localesDisplayNames" ng-click="langCtrl.changeLanguage(localesDisplayName)" eat-click>{{localesDisplayName}}</a></li>'+
		'	</ul>'+
		'</div>',
		controller: 'LanguageSelect as langCtrl',
	};
})

